import { Sidebar } from 'components/Sidebar/Sidebar';
import { MessageV2DTO, PartnerDTO } from 'support/types';
import { PaymentReconciliationDetailsData } from '../../types';
import { FC } from 'react';
import { DocumentProperties, DocumentPropertiesItem } from 'components/Sidebar/SidebarProperties/SidebarProperties';
import { useTranslation } from 'react-i18next';
import { TradePartnerNameAndLogo } from 'components/TradePartnerNameAndLogo';
import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { EMPTY_FIELD } from 'support/helpers/const/const';
import { PaymentReconciliationSummary } from './components/PaymentReconciliationSummary/PaymentReconciliationSummary';
import { PaymentReconciliationSidebarStatusBadge } from './components/PaymentReconciliationSidebarStatusBadge/PaymentReconciliationSidebarStatusBadge';

type PaymentReconciliationDetailsSidebarProps = {
  message: MessageV2DTO | undefined;
  currentPartner: PartnerDTO | undefined;
  paymentReconciliation: PaymentReconciliationDetailsData | undefined;
};
export const PaymentReconciliationDetailsSidebar: FC<PaymentReconciliationDetailsSidebarProps> = ({
  message,
  currentPartner,
  paymentReconciliation,
}) => {
  const { t } = useTranslation();
  const senderPartner = message?.sender_partner;
  const receiverPartner = message?.receiver_partner;

  const otherPartner = currentPartner && senderPartner?.id === currentPartner?.id ? receiverPartner : senderPartner;
  const hasAllNeededData = message && currentPartner && paymentReconciliation;

  const properties: Array<DocumentPropertiesItem> = [
    {
      label: t('webedi:sidebar.properties.partner'),
      key: 'partner',
      value: (
        <TradePartnerNameAndLogo
          partner={otherPartner}
          size="small"
          textConfiguration={{ className: 'text-inherit' }}
          logoConfiguration={{ className: 'rounded-full' }}
        />
      ),
    },
    {
      label: t('webedi:sidebar.properties.status'),
      key: 'status',
      value:
        message && paymentReconciliation?.data.receiver_envelope ? (
          <PaymentReconciliationSidebarStatusBadge
            message={message}
            receiverEnvelope={paymentReconciliation.data.receiver_envelope}
            currentPartner={currentPartner}
          />
        ) : null,
    },
    {
      label: t('webedi:sidebar.properties.documentDate'),
      key: 'document-date',
      value: message ? formatDayAndTime(message.created_at) : EMPTY_FIELD,
    },
    {
      key: 'payment-method',
      label: t('paymentReconciliation:sidebar.properties.paymentMethod'),
      value: paymentReconciliation?.data?.payment_method || EMPTY_FIELD,
    },
    {
      key: 'payment-reference',
      label: t('paymentReconciliation:sidebar.properties.paymentReference'),
      value: paymentReconciliation?.data?.payment_reference || EMPTY_FIELD,
    },
  ];

  return (
    <Sidebar
      bottomSlot={
        paymentReconciliation?.data ? (
          <PaymentReconciliationSummary paymentReconciliation={paymentReconciliation.data} />
        ) : null
      }
    >
      {hasAllNeededData ? <DocumentProperties properties={properties} /> : null}
    </Sidebar>
  );
};
